/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EntitySequence } from './EntitySequence';
import {
    EntitySequenceFromJSON,
    EntitySequenceFromJSONTyped,
    EntitySequenceToJSON,
} from './EntitySequence';

/**
 * 
 * @export
 * @interface StrandsRequest
 */
export interface StrandsRequest {
    /**
     * 
     * @type {Array<EntitySequence>}
     * @memberof StrandsRequest
     */
    entitySequences: Array<EntitySequence>;
}

/**
 * Check if a given object implements the StrandsRequest interface.
 */
export function instanceOfStrandsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entitySequences" in value;

    return isInstance;
}

export function StrandsRequestFromJSON(json: any): StrandsRequest {
    return StrandsRequestFromJSONTyped(json, false);
}

export function StrandsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrandsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entitySequences': ((json['entitySequences'] as Array<any>).map(EntitySequenceFromJSON)),
    };
}

export function StrandsRequestToJSON(value?: StrandsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entitySequences': ((value.entitySequences as Array<any>).map(EntitySequenceToJSON)),
    };
}

